module.exports = __webpack_public_path__ + "img/img1.d43acc68.jpg";